export const GLEAP_GIOTTO_PERSONALIZATION_FORM_ID = '83d9b211efd4bfa41d04';
export const GLEAP_GIOTTO_PERSONALIZATION_TICKET_TYPE =
  'PERSONALIZZAZIONI-GIOTTO';
export const GLEAP_PERSONALIZATION_CUSTOM_ACTION =
  'eterno.personalizzazioni.apri';
export const GLEAP_PERSONALIZATION_AGENT_TOOL = 'open-personalization-request';
export const GLEAP_PERSONALIZATION_CATALOG_EVENT =
  'giotto:open-personalization-catalog';

export const isGleapPersonalizationCustomAction = (actionName) => {
  if (typeof actionName !== 'string') {
    return false;
  }

  const normalizedActionName = actionName.trim().toLowerCase();
  return (
    normalizedActionName === GLEAP_PERSONALIZATION_CUSTOM_ACTION ||
    normalizedActionName.includes('personalizz')
  );
};
